/**
 * 将站内绝对路径（如 /skillhub）拼到 Vite `base` 下，供 <a :href> 等非 router-link 场景使用。
 * 开发时 base 为 /，生产子路径部署时为 /finSkillHub/ 等。
 */
export function withAppBase(absPath: string): string {
  if (absPath === '#' || absPath.startsWith('#')) return absPath
  if (!absPath.startsWith('/')) return absPath
  const base = import.meta.env.BASE_URL
  const normalized = base.endsWith('/') ? base.slice(0, -1) : base
  return `${normalized}${absPath}`
}
